import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.previousTemplateId = null
  }

  changeTemplate(event) {
    const select = event.target
    const templateId = select.value

    if (this.currentTemplateId(select)) {
      const confirmed = confirm("Changing the template will reload the page and any unsaved answers will be lost. Continue?")
      if (!confirmed) {
        select.value = this.previousTemplateId
        return
      }
    }

    this.previousTemplateId = templateId

    const url = new URL(window.location.href)
    if (templateId) {
      url.searchParams.set("template_id", templateId)
    } else {
      url.searchParams.delete("template_id")
    }

    document.getElementById("scouting_report_fields").src = url.toString()
  }

  // The template we are leaving: tracked in memory once the user has changed it
  // themselves, otherwise the value rendered by the server.
  currentTemplateId(select) {
    if (this.previousTemplateId !== null) return this.previousTemplateId

    const rendered = select.querySelector("option[selected]")
    return rendered ? rendered.value : ""
  }
}
